@if (proveedor) {
  <div class="flex items-center gap-3">
    @if (hayFoto) {
      <button
        type="button"
        (click)="abrirAmpliada()"
        aria-label="Ver tarjeta del proveedor en grande"
        class="shrink-0 w-14 h-14 rounded-xl overflow-hidden border border-[var(--border)]"
      >
        @if (blobTarjeta(); as b) {
          <app-mini-foto-blob [blob]="b" alt="Tarjeta del proveedor" className="w-14 h-14 object-cover" />
        } @else {
          @if (urlTarjeta(); as u) {
            <app-foto-remota [url]="u" alt="Tarjeta del proveedor" className="w-14 h-14 object-cover" />
          }
        }
      </button>
    } @else {
      <div class="shrink-0 w-14 h-14 rounded-xl border border-dashed border-[var(--border)] flex items-center justify-center text-[10px] text-[var(--faint)] text-center px-1">
        Sin tarjeta
      </div>
    }
    <div class="min-w-0">
      <div [class]="proveedor.nombre ? 'text-[14px] font-bold truncate' : 'text-[14px] font-bold truncate italic text-[var(--faint)]'">
        {{ proveedor.nombre || '— sin nombre —' }}
      </div>
      @if (proveedor.contacto?.trim()) {
        <div class="text-[11.5px] text-[var(--muted)] truncate">{{ proveedor.contacto }}</div>
      }
    </div>
  </div>

  @if (verAmpliada()) {
    <app-visor-imagen [url]="urlAmpliadaActual!" [titulo]="proveedor.nombre || proveedor.codigo" (cerrar)="cerrarAmpliada()" />
  }
}
